import { createStyles, makeStyles } from '@mui/styles';
import { STYLE } from '../../../../constants';
import { toREM } from 'utils';

export const useStyles = makeStyles((theme: any) =>
  createStyles({
    root: {
      position: 'relative',
      width: '100%',
      height: '48px',
      backgroundColor: STYLE.COLOR.INPUT_BACKGROUND,
      borderRadius: '8px',
      border: `1px solid ${STYLE.COLOR.INPUT_BORDER}`,
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      paddingLeft: 20,
      paddingRight: 20,
      '&:hover': {
        borderColor: STYLE.COLOR.ACCENT_PRIMARY,
      },
      '@media (max-width: 600px)': {
        height: '44px',
      },
    },
    hiddenText: {
      color: STYLE.COLOR.TEXT1,
      fontSize: 24,
      height: 26,
    },
    requiredMark: {
      color: STYLE.COLOR.ERROR,
      paddingLeft: '3px',
    },
    skippableMark: {
      color: STYLE.COLOR.WARNING,
      paddingLeft: '3px',
    },
    label: {
      position: 'absolute',
      top: -12,
      left: 16,
      backgroundColor: STYLE.COLOR.WHITE,
      padding: '4px 6px 4px 6px',
      fontSize: 10,
      color: STYLE.COLOR.TEXT2,
      display: 'flex',
      alignItems: 'center',
      fontWeight: 500,
      height: 24,
      borderRadius: 12,
    },
  }),
);
